import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Popover, useMediaQuery } from '@mui/material';
import cn from 'classnames';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreatePost } from 'src/components/common/Modals/CreatePost/CreatePost';
import { AddMembersModal } from '../../AddMembersModal/AddMembersModal';
import { CreateAuctionModal } from '../Modals/CreateAuctionModal/CreateAuctionModal';
import styles from '../UserInfo.module.scss';

interface UserActionsProps {
  isLeader: boolean;
  tribeId: string;
  leaderId: string;
  leaderName: string;
  auctionId: string;
  tribeAvatar: string;
  account_type: string;
  onMembersChanged?: () => void;
}

export const UserActions: FC<UserActionsProps> = ({
  isLeader,
  tribeId,
  leaderId,
  leaderName,
  auctionId,
  tribeAvatar,
  account_type,
  onMembersChanged,
}) => {
  const [isOpenCreatePostModal, setIsOpenCreatePostModal] = useState(false);
  const [isOpenAddMember, setIsOpenAddMember] = useState(false);
  const [isOpenAuctionModal, setIsOpenAuctionModal] = useState(false);
  const [mobileMenuAnchor, setMobileMenuAnchor] =
    useState<HTMLButtonElement | null>(null);
  const isNarrowMobile = useMediaQuery('(max-width:545px)');

  const navigate = useNavigate();

  const handleEditCircle = () => {
    navigate(`/edit-circle/${tribeId}`);
  };

  if (!isLeader) {
    return null;
  }

  return (
    <div className={styles.buttons}>
      <div className={styles.btnsWrapper}>
        <button
          type="button"
          onClick={() => setIsOpenCreatePostModal(true)}
          className={cn(styles.btn, styles.btnPrimary)}
        >
          <AddIcon fontSize="small" />
          Add Challenge
        </button>
        <button
          type="button"
          onClick={() => setIsOpenAddMember(true)}
          className={cn(styles.btn, styles.btnSecondary)}
        >
          <GroupsOutlinedIcon fontSize="small" />
          Members
        </button>
        {!isNarrowMobile && (
          <button
            type="button"
            className={cn(styles.btn, styles.btnGhost)}
            onClick={handleEditCircle}
          >
            <EditOutlinedIcon fontSize="small" />
            Edit Circle
          </button>
        )}
        {isNarrowMobile && (
          <button
            type="button"
            className={styles.mobileMoreButton}
            onClick={(event) => setMobileMenuAnchor(event.currentTarget)}
            aria-label="More circle actions"
          >
            <MoreHorizIcon />
          </button>
        )}
      </div>
      {!auctionId && account_type === 'AUCTION' && !isNarrowMobile && (
        <div>
          <div className={styles.auctionTitle}>Auction</div>
          <button
            type="button"
            onClick={() => setIsOpenAuctionModal(true)}
            className={cn(styles.btn, styles.btnSecondary)}
          >
            Create an auction
          </button>
        </div>
      )}
      <Popover
        open={Boolean(mobileMenuAnchor)}
        anchorEl={mobileMenuAnchor}
        onClose={() => setMobileMenuAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <div className={styles.mobileActionsMenu}>
          <button
            type="button"
            className={styles.mobileActionItem}
            onClick={() => {
              setMobileMenuAnchor(null);
              handleEditCircle();
            }}
          >
            <EditOutlinedIcon fontSize="small" />
            Edit Circle
          </button>
          {!auctionId && account_type === 'AUCTION' && (
            <button
              type="button"
              className={styles.mobileActionItem}
              onClick={() => {
                setMobileMenuAnchor(null);
                setIsOpenAuctionModal(true);
              }}
            >
              Create an auction
            </button>
          )}
        </div>
      </Popover>
      <CreatePost
        isOpenModal={isOpenCreatePostModal}
        setIsOpenModal={setIsOpenCreatePostModal}
        tribeId={tribeId}
        leaderId={leaderId}
        leaderName={leaderName}
      />

      <CreateAuctionModal
        isOpenModal={isOpenAuctionModal}
        setIsOpenModal={setIsOpenAuctionModal}
        circleId={tribeId}
        circleName={leaderName}
        leaderName={leaderName}
        tribeAvatar={tribeAvatar}
      />

      <AddMembersModal
        isOpenModal={isOpenAddMember}
        setIsOpenModal={setIsOpenAddMember}
        circleId={tribeId}
        tribeName={leaderName}
        isLeader={isLeader}
        leaderId={leaderId}
        leaderName={leaderName}
        account_type={account_type}
        onMembersChanged={onMembersChanged}
      />
    </div>
  );
};
